import {
  createEmptyNameForm,
  type CounterpartyNameForm,
} from '@/modules/counterparty/counterparty-master/types/name-form.ts';
import {
  createEmptyManagerForm,
  type CounterpartyManagerForm,
} from '@/modules/counterparty/counterparty-master/types/manager-form.ts';
import {
  createEmptyAddressForm,
  type CounterpartyAddressForm,
} from '@/modules/counterparty/counterparty-master/types/address-form.ts';
import {
  createEmptyContactForm,
  type CounterpartyContactForm,
} from '@/modules/counterparty/counterparty-master/types/contact-form.ts';
import {
  createEmptyBankDetailsForm,
  type CounterpartyBankDetailsForm,
} from '@/modules/counterparty/counterparty-master/types/bank-details-form.ts';
import {
  createEmptySubordinationForm,
  type CounterpartySubordinationForm,
} from '@/modules/counterparty/counterparty-master/types/subordination-form.ts';
import {
  createEmptyCommentForm,
  type CounterpartyCommentForm,
} from '@/modules/counterparty/counterparty-master/types/comment-form.ts';

export type CounterpartyMasterForm = CounterpartyNameForm &
  CounterpartyManagerForm &
  CounterpartyAddressForm &
  CounterpartyContactForm &
  CounterpartyBankDetailsForm &
  CounterpartySubordinationForm &
  CounterpartyCommentForm;

export function createEmptyMasterForm(): CounterpartyMasterForm {
  return {
    ...createEmptyNameForm(),
    ...createEmptyManagerForm(),
    ...createEmptyAddressForm(),
    ...createEmptyContactForm(),
    ...createEmptyBankDetailsForm(),
    ...createEmptySubordinationForm(),
    ...createEmptyCommentForm(),
  };
}
